import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { IVotingGeneral } from '../../../../models/voting.model';
import { UtilitiesProvider } from '../../../../providers/utilities';
import { EventData } from '../../../../providers/event';
import { ENV } from '@app/env';
import { switchMap } from 'rxjs/operators';
import { NavParams } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { IUser } from '../../../../models/user.model';
import { VotingData } from '../../../../providers/voting';

import * as clientSelectors from '../../../../ngrx/reducers/client.reducer';
import * as userSelectors from '../../../../ngrx/reducers/auth.reducer';

@Component({
  selector: 'app-voting-message',
  templateUrl: 'voting-message.html'
})

export class VotingMessageComponent implements OnInit {

  public config$: Observable<any>;
  @Input('general') public general: IVotingGeneral;
  @Input('votingId') public votingId: string;
  @Input('ponderationType') public ponderationType: 'email' | 'code';
  @Input('language') public language: string;
  @Output('changeView') public changeView: EventEmitter<string> = new EventEmitter();

  public currentUserSubs: Subscription;
  public currentUser: IUser;

  constructor(
    private store: Store<{}>,
    private utilities: UtilitiesProvider,
    private eventData: EventData,
    private navParams: NavParams,
    private votingData: VotingData
  ) { }

  ngOnInit() {
    this.getCurrentUser();
  }

  private getCurrentUser() {
    this.currentUserSubs = this.store.select(userSelectors.getUser).subscribe((currentUser) => {
      if (currentUser) {
        this.currentUser = currentUser;
        this.getConfig();
      }
    })
  }

  /**
   * Get the module configuration
   * 1. If it's an event get the eventInfo
   * 2. If has custom_styles get the ClientInfo
   * 2. If not it's an event get the ClientInfo
   */
  private getConfig() {
    if (this.utilities.validateEventIdParam(this.getEventId())) {
      this.config$ = this.eventData.getEventInfo(ENV.client, this.getEventId())
        .pipe(
          switchMap((eventInfo) => {
            if (eventInfo && eventInfo.custom_style === true) {
              // this.moduleState$ = this.eventData.getModuleState(ENV.client, this.getEventId(), 'commercial_samples');
              return Observable.of(eventInfo);
            }
            return this.store.select(clientSelectors.getClientConfig);
          }));
    } else {
      this.config$ = this.store.select(clientSelectors.getClientConfig);
      // this.moduleState$ = this.store.select(clientSelectors.getClientSingleModule('catalog'));
    }

  }

  public getClientId(): string {
    return ENV.client;
  }

  /**
   * return the clientId
   */
  public getEventId(): string {
    return this.navParams.get('eventId');
  }

  public changeToQuestions(event) {
    switch (this.ponderationType) {
      case 'code':
        return this.changeView.emit(event);
      case 'email':
        this.votingData.saveEventVotingEmailRegister(this.getEventId(), this.votingId, this.currentUser.info.id, this.getUserEmail())
          .subscribe((data) => {
            this.utilities.consoleDecorator('Email was registered', data)
          })
        return this.changeView.emit(this.getUserEmail())
    }
  }

  public getUserEmail(): string {
    return this.currentUser.info.email;
  }

}



// WEBPACK FOOTER //
// ./src/pages/voting/components/voting-message/voting-message.ts